<template>
  <div>
    <div class="content-block">
      <div class="asd-form-section heading-section">
        <h1>
          <ContextMenu
            :items="[
              {icon: 'fa-trash', label: 'Smazat uzivatele', action: deleteUser},
            ]"
          >
            <template #icon>
              <i class="fas fa-bars"></i>
            </template>
          </ContextMenu>
          {{ user.username }}
        </h1>
      </div>
      <div class="asd-form-section">
        <div class="section-title">
          <h5>
            <i class="fas fa-user-edit"></i>
            Údaje
          </h5>
          <div class="section-title-controls">
            <ActiveButton class="asd-btn-confirm asd-btn-single-icon"
                          :click="save"
            >
              <i class="fas fa-save"></i>
            </ActiveButton>
          </div>
        </div>
        <div class="asd-form">
          <div class="grid">
            <div>
              <label>Jméno</label>
              <input v-model="user.name"
                     type="text"
                     class="asd-input"
              />
            </div>
            <div>
              <label>Příjmení</label>
              <input v-model="user.surname"
                     type="text"
                     class="asd-input"
              />
            </div>
            <div>
              <label>Aktivní</label>
              <input v-model="user.enabled"
                     type="checkbox"
                     class="asd-input"
              />
            </div>
            <div>
              <label>Notifikace</label>
              <Multiselect
                v-model="notifications"
                :max="-1"
                label="label"
                trackBy="id"
                valueByPath="id"
                :options="availableNotifications"
              >
              </Multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="asd-form-section">
        <div class="section-title">
          <h5>
            <i class="fas fa-users"></i>
            Uživatelské skupiny
          </h5>
        </div>
        <div class="asd-form">
          <Multiselect
            v-model="user.groups"
            :max="-1"
            label="name"
            trackBy="id"
            :options="$store.getters.userGroups"
            :disabled="!$store.getters.groupedActions.includes('EDIT_OTHER_USERS')"
          >
          </Multiselect>
        </div>
      </div>
    </div>
    <div class="content-block">
      <div class="asd-form-section">
        <div class="section-title">
          <h5>
            <i class="fas fa-key"></i>
            Heslo
          </h5>
          <div class="section-title-controls">
            <ActiveButton v-help.mouse="`Změnit heslo`"
                          class="asd-btn-confirm asd-btn-single-icon"
                          :click="changePassword"
            >
              <i class="fas fa-save"></i>
            </ActiveButton>
          </div>
        </div>
        <div class="asd-form">
          <div class="grid">
            <div>
              <label>Heslo</label>
              <input v-model="passwords.first"
                     type="password"
                     class="asd-input"
              />
              <Password v-model="passwords.first"
                        :strengthMeterOnly="true"
              ></Password>
            </div>
            <div>
              <label>Heslo (znovu)</label>
              <input v-model="passwords.second"
                     type="password"
                     class="asd-input"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Password from 'vue-password-strength-meter'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import ContextMenu from 'CORE/components/context-menu'
import ActiveButton from 'CORE/components/form/active-button'
import ensurePath from 'CORE/utils/ensure-path'
import EventBus from 'CORE/bus'

export default {
    name: 'UsersAdministrationDetail',
    components: {
        Password,
        Multiselect,
        ContextMenu,
        ActiveButton,
    },
    props: {
        userId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            user: {},
            passwords: {
                first: '',
                second: '',
            },
            not: [],
        }
    },
    computed: {
        availableNotifications() {
            return [
                { 'id': 'browser_api', 'label': 'Webové notifikace' },
                { 'id': 'app', 'label': 'Notifikace jen v aplikaci' },
                { 'id': 'email', 'label': 'Emailové notifikace' },
            ]
        },
        notifications: {
            set(value) {
                this.user.settings.notifications.enabledFor = value
            },
            get() {
                return this.user.settings.notifications.enabledFor
            },
        },
    },
    created() {
        this.user = this.$store.getters.userById(this.userId)
        ensurePath(this.user, ['settings/Object', 'notifications/Object', `enabledFor/Array`])
    },
    methods: {
        async save() {
            this.$delete(this.user, 'password')
            await this.$store.dispatch('updateUser', this.user)
            await this.$store.dispatch('currentUserCheck')
            EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
            this.$emit('done')
        },
        async changePassword() {
            if (_.size(this.passwords.first) === 0) {
                this.flash('Heslo musí mít alespoň jeden znak.', 'error')
                return
            }
            if (this.passwords.first === this.passwords.second) {
                await this.$store.dispatch('updateUser', {
                    id: this.user.id,
                    password: this.passwords.first,
                })
                EventBus.$emit('FLASH_OK', { message: 'Heslo změněno' })
            } else {
                EventBus.$emit('FLASH_USER_ERROR', { message: 'Heslo a Heslo (znovu) se musí shodovat' })
            }
        },
        async deleteUser() {
            try {
                await this.$store.dispatch('deleteUser', this.user.id)
                EventBus.$emit('FLASH_OK', { message: 'Vymazano' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
    },
}
</script>

<style scoped lang="scss">
@media (min-width: 0px) and (max-width: 767px) {
  .grid {
    display: grid;
    grid-auto-rows: minmax(60px, auto);
    grid-template-columns: 1fr;
    grid-gap: 5px;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .grid {
    display: grid;
    grid-auto-rows: minmax(60px, auto);
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
  }
}

@media (min-width: 1200px) {
  .grid {
    display: grid;
    grid-auto-rows: minmax(60px, auto);
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 30px;
  }
}
</style>

